import MissionNode from './MissionNode';
import StartNode from './StartNode';
import QuestNode from './QuestNode';

export const nodeTypes = {
  missionNode: MissionNode,
  startNode: StartNode,
  questNode: QuestNode,
};
